
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class TicketTypeService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/types',query);
    }

    create(body: any) {
        return this.post('/type',body);
    }

    find(id) {
        return this.get('/type/'+id);
    }

    update(id, body) {
        return this.put('/type/'+id, body);
    }

    allTicketType() {
        return this.get('/all-type');
    }

    _delete(id) {
        return this.delete('/type/'+id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/TicketType.service.ts